module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Regular-Alphabetic.bffdc11c.woff";